export default __webpack_public_path__ + "aa9f408efa24ab61e4c2b439da6322ad.svg";